export default __webpack_public_path__ + "static/media/coachbetter_Brandmark_Black.315aae05.svg";